'use client'

import { loadStripe, type Stripe } from '@stripe/stripe-js'

import { logger } from './logger'

let stripePromise: Promise<Stripe | null> | null = null

export async function getStripeClient(): Promise<Stripe | null> {
  if (!stripePromise) {
    const publishableKey = process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY

    if (!publishableKey) {
      logger.warn('[Billing] Falta NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY para cargar Stripe.js')
      return null
    }

    stripePromise = loadStripe(publishableKey)
  }

  return stripePromise
}
